<template>
    <div class="profile__aside">
        <div class="profile__aside__inner">
            <div class="profile__aside__info">
                <div class="profile__aside__info__img">
                    <span class="icon-Profile"></span>
                </div>
                <div class="profile__aside__info__text">
                    <span class="profile__aside__info__text__name">{{getUsername()}}</span>
                    <span class="profile__aside__info__text__phone">{{getUser().mobile}}</span>
                </div>
                <a class="profile__aside__info__logout-link" href="javascript:void(0)" @click="logOut">
                    <span class="icon-Exit"></span>
                </a>
            </div>
            <div class="profile__aside__divider"></div>
            <nav class="nav flex-column profile__aside__nav">
                <a class="nav-link profile__aside__nav-link" :class="{active:isActive('profile')}" aria-current="page" href="/profile">
                    <div class="profile__aside__nav-link__content">
                        <span class="icon-Profile"></span>
                        حساب کاربری
                    </div>
                    <span class="icon-Chevron_left"></span>
                </a>
                <a class="nav-link profile__aside__nav-link" :class="{active:isActive('orders')}" href="/profile/orders">
                    <div class="profile__aside__nav-link__content">
                        <span class="icon-Bag"></span>
                        سفارشات من
                    </div>
                    <span class="icon-Chevron_left"></span>
                </a>
                <a class="nav-link profile__aside__nav-link" :class="{active:isActive('wishlist')}" href="/profile/wishlist">
                    <div class="profile__aside__nav-link__content">
                        <span class="icon-Heart"></span>
                        لیست علاقه مندی ها
                    </div>
                    <span class="icon-Chevron_left"></span>
                </a>
                <a class="nav-link profile__aside__nav-link" :class="{active:isActive('waiting-list')}" href="/profile/waiting-list">
                    <div class="profile__aside__nav-link__content">
                        <span class="icon-Notification_bell_on"></span>
                        لیست اطلاع رسانی
                    </div>
                    <span class="icon-Chevron_left"></span>
                </a>
                <a class="nav-link profile__aside__nav-link" href="javascript:void(0)" @click="logOut">
                    <div class="profile__aside__nav-link__content">
                        <span class="icon-Exit"></span>
                        خروج از حساب کاربری
                    </div>
                    <span class="icon-Chevron_left"></span>
                </a>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProfileSidebar",
    methods: {
        isActive(item) {
            let active = 'profile';

            if (window.location.href.indexOf('wishlist') > -1) {
                active = 'wishlist';
            } else if (window.location.href.indexOf('waiting-list') > -1) {
                active = 'waiting-list';
            } else if (window.location.href.indexOf('orders') > -1) {
                active = 'orders';
            }

            return item === active;
        },
        logOut() {
            this.axios.post(this.route('api.logout')).then(response => {
                localStorage.removeItem('_token');
                window.location.href = '/';
            });
        }
    }
}
</script>

<style scoped>

</style>
